module.exports = __webpack_public_path__ + "img/8040d55839dcfdab4291b2acfaa89d16.45e23ffa.png";